import React, { useState } from "react";
import {
  Card,
  CardContent,
  Grid,
  makeStyles,
  Tab,
  Tabs,
} from "@material-ui/core";
import SanitizedGrid from "../../components/SanitizedGrid";
import TabPanel from "../routeplans/components/TabPanel";
import SubcontractorAdjustmentPriceTable from "./components/SubcontractorAdjustmentPriceTable";
import { ListProps } from "react-admin";
import HeaderContent from "../../components/layout/components/HeaderContent";

const useStyles = makeStyles({
  sidePanelTabs: {
    borderBottom: "1px solid #C4C4C4",
    "& .MuiTabs-fixed > .MuiTabs-indicator": {
      backgroundColor: "#989898 !important",
      height: "3px !important",
    },
  },
});

const SubcontractorAdjustmentPriceList = (props: ListProps) => {
  const [valueAdjustmentPriceListTab, setValueAdjustmentPriceListTab] =
    useState(0);

  const classes = useStyles();

  const handleChangeAdjustmentPriceListTab = (
    event: React.ChangeEvent<{}>,
    newValue: number,
  ) => {
    setValueAdjustmentPriceListTab(newValue);
  };
  const adjustmentPriceListProps = (index: number) => {
    return {
      id: `adjustmentPriceList-tab-${index}`,
      "aria-controls": `adjustmentPriceList-tabpanel-${index}`,
    };
  };

  const breadcrumb = [
    {
      link: "/subcontractorAdjustmentPrices",
      title: "Subcontractor Adjustment Prices",
    },
  ];

  return (
    <>
      <HeaderContent
        breadcrumb={breadcrumb}
        headerTitle="Subcontractor Adjustment Prices"
      />

      <Card>
        <CardContent>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Tabs
                value={valueAdjustmentPriceListTab}
                onChange={handleChangeAdjustmentPriceListTab}
                aria-label="Subcontractor Adjustment Price List"
                className={classes.sidePanelTabs}
              >
                <Tab
                  label="Approved Adjustment Prices"
                  {...adjustmentPriceListProps(0)}
                />
                <Tab
                  label="Unapproved Adjustment Prices"
                  {...adjustmentPriceListProps(1)}
                />
                <Tab
                  label="Rejected Adjustment Prices"
                  {...adjustmentPriceListProps(2)}
                />
              </Tabs>

              <TabPanel value={valueAdjustmentPriceListTab} index={0}>
                <Grid item xs={12}>
                  <SubcontractorAdjustmentPriceTable
                    status="Approved"
                    isFixedHeight
                  />
                </Grid>
              </TabPanel>

              <TabPanel value={valueAdjustmentPriceListTab} index={1}>
                <Grid item xs={12}>
                  <SubcontractorAdjustmentPriceTable
                    status="Draft"
                    isFixedHeight
                  />
                </Grid>
              </TabPanel>

              <TabPanel value={valueAdjustmentPriceListTab} index={2}>
                <Grid item xs={12}>
                  <SubcontractorAdjustmentPriceTable
                    status="Rejected"
                    isFixedHeight
                  />
                </Grid>
              </TabPanel>
            </Grid>
          </SanitizedGrid>
        </CardContent>
      </Card>
    </>
  );
};

export default SubcontractorAdjustmentPriceList;
